// assets
import BinanceImage from '@/assets/images/network/Binance.png';
import ETHImage from '@/assets/images/network/ETH.png';

// interfaces
import { Network } from '@/interfaces';

export const EthereumNetwork: Network = {
  mainnet: [1],
  testnet: [3, 4, 42, 61, 62],
  icon: ETHImage,
};

export const BSCNetwork: Network = {
  mainnet: [56],
  testnet: [97],
  icon: BinanceImage,
};
